(() => {
  const selector = '[data-kl-scroll-locking-modal="true"]';
  const recovered = new Map();
  const pending = new Map();
  let scheduled = false;
  let lastPageFocus = null;

  const isClosing = (modal) => getComputedStyle(modal).animationName.split(',').some((name) => name.trim() === 'klaviyo-fadeout');
  const isVisible = (modal) => {
    const style = getComputedStyle(modal);
    return style.display !== 'none' && style.visibility !== 'hidden';
  };

  const releaseScroll = () => {
    if (document.body.classList.contains('klaviyo-prevent-body-scrolling') && ![...document.querySelectorAll(selector)].some((modal) => !recovered.has(modal) && isVisible(modal))) {
      document.body.classList.remove('klaviyo-prevent-body-scrolling');
    }
  };

  const recover = (modal) => {
    pending.delete(modal);
    if (!modal.isConnected || recovered.has(modal) || !isClosing(modal) || Number(getComputedStyle(modal).opacity) > 0.01) return;
    recovered.set(modal, {
      display: modal.style.getPropertyValue('display'),
      priority: modal.style.getPropertyPriority('display'),
      ariaHidden: modal.getAttribute('aria-hidden'),
      inert: modal.hasAttribute('inert')
    });
    const restoreFocus = modal.contains(document.activeElement);
    modal.style.setProperty('display', 'none', 'important');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('inert', '');
    releaseScroll();
    if (restoreFocus && lastPageFocus?.isConnected) lastPageFocus.focus({ preventScroll: true });
  };

  const scan = () => {
    scheduled = false;
    for (const [modal, saved] of recovered) {
      if (!modal.isConnected) {
        recovered.delete(modal);
      } else if (!isClosing(modal)) {
        if (saved.display) modal.style.setProperty('display', saved.display, saved.priority);
        else modal.style.removeProperty('display');
        if (saved.ariaHidden === null) modal.removeAttribute('aria-hidden');
        else modal.setAttribute('aria-hidden', saved.ariaHidden);
        if (!saved.inert) modal.removeAttribute('inert');
        recovered.delete(modal);
      }
    }
    for (const [modal, timer] of pending) {
      if (!modal.isConnected || !isClosing(modal)) {
        clearTimeout(timer);
        pending.delete(modal);
      }
    }
    for (const modal of document.querySelectorAll(selector)) {
      if (!recovered.has(modal) && !pending.has(modal) && isClosing(modal)) {
        const style = getComputedStyle(modal);
        const milliseconds = (value) => Math.max(...value.split(',').map((part) => parseFloat(part) * (part.trim().endsWith('ms') ? 1 : 1000)), 0);
        const delay = Math.max(750, milliseconds(style.animationDuration) + milliseconds(style.animationDelay) + 250);
        pending.set(modal, setTimeout(() => recover(modal), delay));
      }
    }
    if (recovered.size) releaseScroll();
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    setTimeout(scan, 50);
  };

  document.addEventListener('focusin', (event) => {
    if (event.target instanceof Element && !event.target.closest(selector)) lastPageFocus = event.target;
  });
  document.addEventListener('animationend', (event) => {
    if (event.animationName === 'klaviyo-fadeout' && event.target.matches(selector)) {
      clearTimeout(pending.get(event.target));
      recover(event.target);
    }
  });
  new MutationObserver((records) => {
    if (records.some((record) => record.type === 'childList' || record.target.matches(selector) || (record.target === document.body && recovered.size))) schedule();
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'data-kl-scroll-locking-modal', 'class']
  });
  scan();
})();
